import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '企业',
      clearable: true,
      placeholder: '请选择企业',
      filterable: true,
      options: []
    },
    {
      label: '账户ID',
      field: 'userId',
      clearable: true,
      type: 'input',
      placeholder: '请输入账户ID'
    },
    {
      label: '使用人',
      field: 'usedBy',
      type: 'select',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '承接日期',
      clearable: false,
      otherOptions: {
        ctlField: 'callTime',
        check(value: any) {
          return value[0] != value[1]
        },
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'deadline',
      type: 'datepicker',
      label: '删除截止日期',
      clearable: false,
      otherOptions: {
        type: 'date',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
  ]
}
